module.exports = __webpack_public_path__ + "static/media/hs_logo.c4bac6ef.png";